<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-row>
        <el-col>
          <span>客户名称: {{customer.name}}&nbsp;&nbsp;&nbsp;&nbsp; 当前账户余额: {{customer.balance}}</span>
        </el-col>
      </el-row>
    </layout-panel>
    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="amount"
                         label="消费金额"></el-table-column>
        <el-table-column prop="deduct_time"
                         label="消费时间"></el-table-column>
        <el-table-column prop="taskid"
                         label="相关任务"></el-table-column>
        <el-table-column prop="managementfee"
                         label="管理费用">
          <template slot-scope="scope">
            {{scope.row.managementfee}}
          </template>
        </el-table-column>
        <el-table-column prop="desc"
                         label="备注"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      // 表格数据
      table: [],
      search: {
        customerId: this.$route.params.id,
      },
      // 搜索字段申明
      searchFieldType: {
        customerId: Number,
      },
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      customer: {
        name: this.$route.query.customername,
        balance: null,
      },

    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.getCustomerBalance()
  },
  methods: {
    ...Vuex.mapActions(['getTekeCustomerBalanceTable', 'getTekeCustomerBalance']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getTekeCustomerBalanceTable', params)
    },
    getCustomerBalance () {
      return request.page('getTekeCustomerBalance', this.search.customerId).then(({data}) => {
        filter.setLoop(this.customer, data)
      })
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/teke-customer/pages/TekeCustomerBalanceTable.vue